import Api from "@/services/api";

const basic = "formulaires";
export default {
  get() {
    return Api.default().get("/" + basic);
  },
};
